import { Component, Input, OnInit } from '@angular/core';
import { AffiliationCodeMetadataLego } from '../../shared/dto/affiliation-code-metadata.lego';

@Component({
  selector: 'wl-affiliation-code-lego-summary',
  templateUrl: './affiliation-code-lego-summary.component.html',
  styleUrls: ['./affiliation-code-lego-summary.component.less'],
    standalone: false
})
export class AffiliationCodeLegoSummaryComponent implements OnInit {
  @Input() affiliationCodeData: AffiliationCodeMetadataLego;

  constructor() {}

  ngOnInit(): void {}
}
